import { useEffect } from 'react';

/**
 * useResizeObserver
 *
 * @param ref - React ref to a DOM element
 * @param callback - Function called with ResizeObserverEntry[] when the element is resized
 */
export function useResizeObserver<T extends Element>(
    ref: React.RefObject<T>,
    callback: (entries: ResizeObserverEntry[]) => void
) {
    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return;
        }

        const observer = new ResizeObserver(entries => {
            if (!document.body.contains(node)) {
                cleanup();
                return;
            }
            callback(entries);
        });
        function cleanup() {
            observer.disconnect();
        }
        observer.observe(node);
        return cleanup;
    }, [ref, callback]);
}
